import Vue from "vue";
import Router from "vue-router";
Vue.use(Router);

export default new Router({
  routes: [
    {
      name: "home",
      path: "/home",
      component: () => import("../home"),
    },
    {
      name: "map",
      path: "/map/:username",  // 使用固定路径
      component: () => import("@/view/map/index"),
    },
  ],
  base: process.env.BASE_URL,
});
